import { render } from "./IconLightning.vue?vue&type=template&id=a40fb0aa"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconLightning.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a40fb0aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a40fb0aa', __exports__)) {
    api.reload('a40fb0aa', __exports__)
  }
  
  module.hot.accept("./IconLightning.vue?vue&type=template&id=a40fb0aa", () => {
    api.rerender('a40fb0aa', render)
  })

}


export default __exports__